<template>
    <div class="login" :key="k">
        <template v-if="logged">
            <b-container fluid>
                <b-row><b-col><br><br><br><br><br><br></b-col></b-row>
                <b-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                        <b-form @submit="logout" class="logoutform">
                            <b-button type="submit" variant="primary">LOGOUT</b-button>
                        </b-form>
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-alert :show="dismissCountDown2" dismissible variant="warning" @dismissed="dismissCountDown2=0" @dismiss-count-down="countDownChanged2" >
                            <p>{{ message }}</p>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="3"></b-col>
                    <b-col cols="6">
                        <h2>Change password</h2>
                        <b-form @submit="chgpass">
                            <b-form-group id="input-group-1" label="old password" label-for="input-1" description="Insert your current pasword" >
                                <b-form-input id="input-1" v-model="newpass.oldpass" type="password" placeholder="Enter your current password" required ></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" label="new password" label-for="input-1" description="Insert your new pasword: 8 chars minimum, with both uppercase and lowercase letters, almost one number and one special char" >
                                <b-form-input id="input-1" v-model="newpass.newpassword" type="password" placeholder="Enter your new password" required ></b-form-input>
                            </b-form-group>
                            <b-form-group id="input-group-1" label="new password" label-for="input-1" description="Insert your new pasword" >
                                <b-form-input id="input-1" v-model="newpass.newpassword2" type="password" placeholder="Reenter your new password" required ></b-form-input>
                            </b-form-group>
                            <b-button type="submit" variant="primary">Confirm</b-button>
                        </b-form>
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-row>
            </b-container>
		</template>
        <template v-else>
            <br />
            <h2 class="t50">Welcome Back!</h2>
            <b-form @submit="onSubmit" class="loginform">
                <b-form-group
                    id="input-group-1"
                    label="User:"
                    label-for="input-1"
                    description="Not registered ? Ask Marsilli for an account"
                >
                    <b-form-input
                        id="input-1"
                        v-model="form.login"
                        type="text"
                        placeholder="Enter login"
                        required
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="input-group-2"
                    label="Password:"
                    label-for="input-2"
                    description="Lost password ? Ask Marsilli for a reset"
                >
                    <b-form-input
                        id="input-2"
                        type="password"
                        v-model="form.password"
                        placeholder="Enter password"
                        required
                    ></b-form-input>
                </b-form-group>
                <template v-if="prelogged">
                    <model-select
                        :options="optclients"
                        v-model="client"
                        placeholder="selezionare cliente"
                    ></model-select>
                    <multi-select
                        :options="optmacchine"
                        :selected-options="selmacchine"
                        @select = "mselect"
                    ></multi-select>
                </template>
                <br><br><br><br><br>
                <b-button type="submit" variant="primary">LOGIN</b-button>
            </b-form>
            <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                variant="danger"
                @dismissed="dismissCountDown = 0"
                @dismiss-count-down="countDownChanged"
            >
                Wrong User or Password
            </b-alert>
        </template>
    </div>
</template>

<script>
import { API } from "@/api.js";
import { ModelSelect } from "vue-search-select";
import { MultiSelect } from "vue-search-select";

import 'vue-search-select/dist/VueSearchSelect.css'

export default {
    name: "Home",
    data() {
        return {
            priv: false,
            prelogged: false,
            dismissCountDown: 0,
            dismissCountDown2: 0,
            dismissSecs: 5,
            k: 0,
            form: {
                login: this.$store.getters.login || "",
                password: "",
            },
            newpass: {
                oldpass: "",
                newpassword: "",
                newpassword2: "",
            },
            message: "",
            optclients: [],
            client: false,
            optmacchine: [],
            selmacchine: [],
        };
    },
    watch: {
        async client(nV) {
            this.fillOptMacchine(nV)
        },
        form: {
            async handler(newData) {
                // questo pre-log serve per far vedere e scegliere le macchine ai tecnici Marsilli
                if(newData.login>"" && newData.password>"" ) {
                    try {
                        if(this.form.password.endsWith("+private")) {
                            this.priv = true
                            this.form.password = this.form.password.slice(0,-8)
                        }
                        let user = await API.login(this.form.login, this.form.password);
                        this.prelogged = false
                        if(user) {
                            user.auth = false
                            this.$store.commit("login", user);
                            this.$store.commit("prelogged", true);
                            let res = await API.getPrivacy();
                            console.log("privacy", res);
                            if (res) {
                                console.log("setto privacyOK")
                                this.$store.commit("privacyOK",null);
                            }
                            if(!this.$store.getters.client_code && !this.$store.getters.master) { // è Marsilli NON master
                                this.prelogged = true
                                this.getClients()
                                this.fillOptMacchine()
                            }
                        } 
                    } catch (error) { 
                        // login non valido
                        console.log("error",error)
                    }
                }
            },
            deep: true
        }
    },
    components: {
        ModelSelect,
        MultiSelect
    },
    mounted() {
        // this.$store.commit("logout");
    },
    computed: {
        logged() {
            // console.log("logged", this.$store.getters.logged);
            return this.$store.getters.logged
        },
    },
    methods: {
        async fillOptMacchine(client){
            console.log("client",client)
            let possibleUnits = await API.getPossibleUnits()
            console.log({possibleUnits})
            possibleUnits = possibleUnits.map(r => ({ text: r.code, value: r.code, client_code: r.client_code }))
            let opt = possibleUnits.filter(r => (r.client_code == client || !client) && !!r.value)
            console.log({opt})
            // le ordino e le rendo uniche
            this.optmacchine = opt.sort((a,b) => a.value.localeCompare(b.value)).filter((v,i,a) => a.findIndex(v => v.value==a[i].value) == i)
            console.log("opt macchine",this.optmacchine)
        },
        async mselect(a) {
            console.log("mselect",a,this.client)
            if(a && a.length==1 && this.client==false) {
                this.client = a[0].client_code
                await this.fillOptMacchine(this.client)
                this.selmacchine = a
            } else if(a && a.length<20)
                this.selmacchine = a
        },
        async getClients(){
            if(this.prelogged) {
                this.optclients = (await API.getClients()).map(r => ({text: r.name, value:r.code})).sort((a,b) => a.text.localeCompare(b.text))
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        countDownChanged2(dismissCountDown2) {
            this.dismissCountDown2 = dismissCountDown2;
        },
		logout(event){
			event.preventDefault();
            this.form.login = ""
			this.$store.commit("login", null);
            this.priv = false
            this.$store.commit("private", this.priv);
            console.log("logout")
            localStorage.setItem("dateChecked","false")
		},
        async chgpass(event){
            event.preventDefault();
            console.log("qua", this.form);
            if(this.newpass.newpassword!=this.newpass.newpassword2) {
                this.message = "The new password doesn't match"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            if(this.newpass.newpassword.length<8) {
                this.message = "The new password isn't long enough"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            if(! /[A-Z]/.test(this.newpass.newpassword)) {
                this.message = "The new password doesn't contains uppercase letters"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            if(! /[a-z]/.test(this.newpass.newpassword)) {
                this.message = "The new password doesn't contains lowercase letters"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            if(! /[0-9]/.test(this.newpass.newpassword)) {
                this.message = "The new password doesn't contains numbers"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            // eslint-disable-next-line no-useless-escape
            if(! /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.newpass.newpassword)) {
                this.message = "The new password doesn't contains any special char"
                this.dismissCountDown2 = this.dismissSecs;
                return
            }
            let ret = await API.chgpass(this.newpass.oldpass, this.newpass.newpassword);
            if(ret.ok) {
                this.message = ret.msg
                this.dismissCountDown2 = this.dismissSecs;
                this.$router.push("/scmachines");
            } else {
                this.message = ret.msg
                this.dismissCountDown2 = this.dismissSecs;
            }
        },
        async onSubmit(event) {
            console.log("SUBMIT !!!???!!!")
            event.preventDefault();
            // let priv = false
            // if(this.form.password.endsWith("+private")) {
            //     priv = true
            //     this.form.password = this.form.password.slice(0,-8)
            // }
            // console.log("form",this.form)
            localStorage.setItem("password", this.form.password);
            let user = await API.login(this.form.login, this.form.password,this.selmacchine.map(m => m.value));
            this.$store.commit("login", user);
            this.$store.commit("prelogged", false);
            console.log("user",user)
            let pok = await API.getPrivacy()
            if(pok)
                this.$store.commit("privacyOK",null);
            console.log("pok",pok)
            this.k = this.k+1;
            this.$forceUpdate();
            console.log("K",this.k)
            if (this.$store.getters.logged) {
                if(pok) {
                    this.$store.commit("private", this.priv);
                    this.$router.push("/choose");
                }
            } else {
                this.dismissCountDown = this.dismissSecs;
            }
        },
    },
};
</script>
<style scoped>
div.login {
    background-color: #cddecd;
    height: calc(100vh - 120px);
}
h2.t50 {
    font-weight: bold;
    position: relative;
    top: 50px;
}
form.loginform {
    display: inline-block;
    position: relative;
    top: 50px;
    width: 50%;
}
form button {
    position: absolute;
    right: 0px;
	left: 0px;
    background-color: #9a240d !important;
    border-color: #9a240d !important;
}
form button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
form button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
form.logoutform {
    height: 100px;
}
form.logoutform button {
    position: absolute;
    right: 0px;
	left: 0px;
    background-color: #9a240d !important;
    border-color: #9a240d !important;
}
form.logoutform button:hover {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
form.logoutform button:active {
    box-shadow: 0 0 0 .2rem rgba(154, 36, 13, 0.5 ) !important;
}
</style>
<style>
form.loginform label {
    text-align: left;
}
</style>
